"use client"
import { useController } from 'react-hook-form';

import { Grid } from '@/stories/organisms/Grid/Grid';
import { Input } from '@/stories/components/Form/Input/Input';
import { Textarea } from '@/stories/components/Form/Textarea';
import { LocalitySearch } from '@/stories/components/Form/LocalitySearch/LocalitySearch';
import { CustomSelect, type Option } from '@/stories/components/Form/CustomSelect/CustomSelect';
import { EstimationFormContentProps } from './EstimationForm';
import { Radio } from '@/stories/components/Form/Radio/Radio';
import { FormIemGroup } from '@/stories/components/Form/FormIemGroup/FormIemGroup';

export const InfosStep = ({
  typeBiens,
  context
}: {
  typeBiens: Option[],
  context: EstimationFormContentProps['context']
}) => {
  const {
    field: tb,
    fieldState: { error: tbError },
  } = useController({
    name: 'tb',
  })

  const {
    field: address,
    fieldState: { error: addressError },
  } = useController({
    name: 'address',
  })

  const {
    field: locality,
    fieldState: { error: localityError },
  } = useController({
    name: 'locality'
  })

  const {
    field: nbRoom,
    fieldState: { error: nbRoomError },
  } = useController({
    name: 'nbRoom'
  })

  const {
    field: surface,
    fieldState: { error: surfaceError },
  } = useController({
    name: 'surface'
  })

  const {
    field: type,
  } = useController({
    name: 'type'
  })

  const {
    field: comment,
    fieldState: { error: commentError },
  } = useController({
    name: 'comment'
  })

  return (
    <>
      <CustomSelect
        value={{label: tb.value, value: tb.value}}
        setValue={(value: string) => tb.onChange(value)}
        options={typeBiens}
        name="tb"
        label="Type de bien"
        errorText={tbError?.message}
        variant='secondary'
        icon='house'
        searchable
        inline/>
      <Grid nbCols={2}>
        <Input
          value={address.value}
          setValue={(value: string) => address.onChange(value)}
          errorText={addressError?.message}
          label='Adresse'
          name='address'
          placeholder='55 Rue du Faubourg Saint-Honoré'
          variant='secondary'
          required/>
        <LocalitySearch
          localityTypes={['commune', 'arrondissement']}
          excludeArrondissementCities
          localities={locality.value ? [locality.value] : []}
          setLocalities={(value) => {
            locality.onChange(value[0])
          }}
          errorText={localityError?.message}
          label='Commune'
          icon='location-dot'
          variant='secondary'
          required
          />
      </Grid>
      <Grid nbCols={2}>
        <Input
          value={nbRoom.value}
          setValue={(value: string) => nbRoom.onChange(parseInt(value))}
          errorText={nbRoomError?.message}
          name='nbRoom'
          variant='secondary'
          label='Nombre de pièces'
          id='nbRoom'
          type='number'
          min={0}
          placeholder='3'
          icon='door-closed'/>
        <Input
          value={surface.value}
          setValue={(value: string) => surface.onChange(parseInt(value))}
          errorText={surfaceError?.message}
          name='surface'
          variant='secondary'
          label='Surface en m²'
          id='surface'
          type='number'
          min={0}
          placeholder='55'
          icon='draw-square'/>
      </Grid>
      {context === 'global' && (
        <FormIemGroup label='Type' required>
          <Grid nbCols={2}>
            <Radio
              label={'Estimation prix de vente'}
              name='type'
              value={'sell'}
              variant='secondary'
              onChange={() => type.onChange('sell')}
              checked={type.value === 'sell'}
              />
            <Radio
              label={'Estimation locative'}
              name='type'
              value={'rent'}
              variant='secondary'
              onChange={() => type.onChange('rent')}
              checked={type.value === 'rent'}
              />
          </Grid>
        </FormIemGroup>
      )}
      <Textarea
        value={comment.value}
        setValue={(value: string) => comment.onChange(value)}
        errorText={commentError?.message}
        name='comment'
        variant='secondary'
        label='Commentaire'
        id='comment'
        placeholder='Décrivez votre demande ou besoins en quelques lignes..'/>
    </>
  )
};